import service from "@/utils/request";

export function getMessageList(params) {
    return service({
        url: "/system/message/page",
        method: "get",
        params,
    });
}

export function getMessageDetail(params) {
    return service({
        url: "/system/message/detail",
        method: "get",
        params,
    });
}
export function createMessage(data) {
    return service({
        url: "/system/message/create",
        method: "post",
        data,
    });
}
export function updateMessage(data) {
    return service({
        url: "/system/message/update",
        method: "post",
        data,
    });
}
export function publishMessage(data) {
    return service({
        url: "/system/message/publish?id=" + data.id,
        method: "post",
    });
}
export function deleteMessage(data) {
    return service({
        url: "/system/message/delete?id=" + data.id,
        method: "post",
    });
}

